module.exports = __webpack_public_path__ + "static/media/billboard.5a882e8d.png";